import { Component } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import _ from "underscore";

import { filterType, filter_display } from "../services/filtering";

import DateFilter from "./Filters/Date";
import EnumFilter from "./Filters/Dropdown";

import { CELL_TYPES } from "../index";
import PropTypes from "prop-types";

export default class HeaderFilters extends Component {
  filter = (key, tableKey, event) => {
    this.props.changeFilterValue(key, tableKey, event.target.value);
  };

  render() {
    let { tables, tableKey, selectId, detailsRenderer, columns } = this.props;
    let currentFilter = tables[tableKey].currentFilter;
    let showDetails = !!detailsRenderer;
    let allowSelections = !!selectId;

    let renderColumns = _.filter(columns, (col) => {
      return col.visible !== false;
    });

    let selections;
    if (allowSelections) selections = this.getSelectionTemplate();

    let details;
    if (showDetails) details = <td />;

    let actionColumn;
    if (renderColumns[renderColumns.length - 1].label == "Actions")
      actionColumn = this.getActionTemplate();

    return (
      <tr>
        {selections}
        {details}
        {renderColumns.map((column, index) => {
          if (
            column.filter === false ||
            !column.type ||
            column.type === CELL_TYPES.ssn
          )
            return <td key={index} />;
          let filterType = currentFilter[column.key].type;
          let nextFilterType = this.getNextFilterType(
            currentFilter[column.key].type,
            column.type,
          );
          let filterValue = currentFilter[column.key].filter;

          let filterProps = {
            filterValue,
            enumDict: column.enumDict,
            filter: this.props.changeFilterValue.bind(
              this,
              column.key,
              tableKey,
            ),
          };

          if (column.type === CELL_TYPES.date) {
            return (
              <td key={index}>
                <DateFilter {...filterProps} />
              </td>
            );
          }

          if (column.type === CELL_TYPES.enum) {
            return (
              <td key={index}>
                <EnumFilter {...filterProps} />
              </td>
            );
          }
          if (column.type === CELL_TYPES.listOfEnum) {
            return (
              <td key={index}>
                <EnumFilter {...filterProps} />
              </td>
            );
          }

          return (
            <td key={index}>
              <div style={{ position: "relative" }}>
                <span
                  className="header-table-filter-type"
                  onClick={this.props.changeFilterType.bind(
                    this,
                    column.key,
                    nextFilterType,
                    tableKey,
                  )}
                >
                  {filter_display[filterType]}
                </span>
                <input
                  className="header-table-filter-input"
                  type="text"
                  onChange={this.filter.bind(this, column.key, tableKey)}
                  value={filterValue}
                />
              </div>
            </td>
          );
        })}
        {actionColumn}
      </tr>
    );
  }

  getSelectionTemplate = () => {
    let { tableKey, tables, items } = this.props;
    let selected = tables[tableKey].selections;

    items = items || [];

    let selectedLength = Object.keys(selected).length;

    let allSelected = selectedLength === items.length && selectedLength != 0;

    return (
      <td>
        <Checkbox checked={allSelected} onClick={this.selectAll} />
      </td>
    );
  };

  getActionTemplate = () => {
    let { actionColumnWidth } = this.props;
    return (
      <td className="action-column" style={{ width: actionColumnWidth }}>
        <div style={{ textAlign: "center", display: "block" }}>&nbsp;</div>
      </td>
    );
  };

  getNextFilterType = (type, columnType) => {
    if (type == filterType.EUQAL && columnType == CELL_TYPES.text)
      return filterType.CAONTAINS;
    if (type == filterType.EUQAL) return filterType.LESS_THAN;
    if (type == filterType.LESS_THAN) return filterType.MORE_THAN;
    if (type == filterType.MORE_THAN && columnType == CELL_TYPES.text)
      return filterType.CAONTAINS;
    if (type == filterType.MORE_THAN) return filterType.EUQAL;
    if (type == filterType.CAONTAINS) return filterType.EUQAL;
  };

  selectAll = () => {
    let { tableKey, selectId, tables, items } = this.props;
    let selected = tables[tableKey].selections;
    let allSelected = Object.keys(selected).length === items.length;
    let newSelected = {};
    if (!allSelected) {
      for (let i = 0; i < items.length; i++) {
        let element = items[i];

        newSelected[element[selectId]] = true;
      }
    }

    this.props.selectAll(newSelected, tableKey);
  };

  static propTypes = {
    changeFilterValue: PropTypes.func,
    changeFilterType: PropTypes.func,
    selectAll: PropTypes.func,
    tables: PropTypes.object,
    actionColumnWidth: PropTypes.any,
    items: PropTypes.array,
    tableKey: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    selectId: PropTypes.any,
    detailsRenderer: PropTypes.any,
  };
}
